<div class="zuper-drawer-content">
    <ng-content></ng-content>
</div>